import calls from '@/backend/api-calls'

const state = () => ({
  rfq: null,
  selected: [],
  allSelected: false,
  loading: false,
  firstLoad: true
})

// getters
const getters = {
  isMitrex: state => state.rfq.product_brand == 'Mitrex',
  rfqEndpoint: (state, getters) => {
    return getters.isMitrex ? 'mitrexRfq' : 'cladifyRfq'
  },
  estimationServices: (state, getters) => { 
    return getters.isMitrex ? 'estimationServicesMitrex' : 'estimationServices' 
  },
  estimationService: (state, getters) => { 
    return getters.isMitrex ? 'estimationServiceMitrex' : 'estimationService' 
  },
  estimationItems: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemsMitrex' : 'estimationItems' 
  },
  estimationItem: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemMitrex' : 'estimationItem' 
  },
  estimationItemMaterials: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemMaterialsMitrex' : 
      'estimationItemMaterials' 
  },
  estimationItemMaterial: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemMaterialMitrex' : 
      'estimationItemMaterial' 
  },
  estimationItemProcessings: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemProcessingsMitrex' : 
      'estimationItemProcessings' 
  },
  estimationItemProcessing: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemProcessingMitrex' : 
      'estimationItemProcessing' 
  },
  estimationItemFabrications: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemFabricationsMitrex' : 
      'estimationItemFabrications' 
  },
  estimationItemFabrication: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemFabricationMitrex' : 
      'estimationItemFabrication' 
  },
  estimationItemInstallations: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemInstallationsMitrex' : 
      'estimationItemInstallations' 
  },
  estimationItemInstallation: (state, getters) => { 
    return getters.isMitrex ? 'estimationItemInstallationMitrex' : 
    'estimationItemInstallation' 
  }
}

// actions
const actions = {
  getRfq: ({commit}, rfqId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.rfq.get(rfqId)
        .then(resp => {
          commit("setRfq", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  updateRfq: ({commit, getters}, { rfqId, data }) => {
    return new Promise((resolve, reject) => {
      calls[getters.rfqEndpoint].put(rfqId, data).then(
        resp => {
          commit("setRfq", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addDocument: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.rfqDocuments.post(data).then(
        resp => {
          commit("insertDocument", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateDocument: ({commit}, {documentId, data}) => {
    return new Promise((resolve, reject) => {
      calls.rfqDocument.put(documentId, data).then(
        resp => {
          commit("insertUpdatedDocument", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteDocument: ({commit}, documentId) => {
    return new Promise((resolve, reject) => {
      calls.rfqDocument.delete(documentId).then(
        resp => {
          commit("removeDocument", documentId);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addService: ({commit, getters}, data) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationServices].post(data).then(
        resp => {
          commit("insertService", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteService: ({commit, getters}, serviceId) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationService].delete(serviceId).then(
        resp => {
          commit("removeService", serviceId);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addEstimation: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.cladifyEstimations.post(data).then(
        resp => {
          commit("insertEstimation", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addItem: ({commit, getters}, data) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItems].post(data).then(
        resp => {
          commit("insertItem", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Rfq item successfully added'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateItem: ({commit, getters}, {itemId, data}) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItem].put(itemId, data).then(
        resp => {
          commit("insertUpdatedItem", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteItem: ({commit, getters}, itemId) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItem].delete(itemId).then(
        resp => {
          commit("removeItem", itemId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Rfq item successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addItemMaterial: ({commit, getters}, { data, replaceIndex }) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemMaterials].post(data).then(
        resp => {
          commit("insertItemMaterial", { 
            data: resp.data, replaceIndex: replaceIndex 
          });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateItemMaterial: ({commit, getters}, {itemMaterialId, data}) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemMaterial].put(itemMaterialId, data).then(
        resp => {
          commit("insertUpdatedItemMaterial", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteItemMaterial: ({commit, getters}, itemMaterialId) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemMaterial].delete(itemMaterialId).then(
        resp => {
          commit("removeItemMaterial", itemMaterialId);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addItemProcessing: ({commit, getters}, { data, replaceIndex }) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemProcessings].post(data).then(
        resp => {
          commit("insertItemProcessing", { 
            data: resp.data, replaceIndex: replaceIndex 
          });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateItemProcessing: ({commit, getters}, {itemProcessingId, data}) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemProcessing].put(itemProcessingId, data).then(
        resp => {
          commit("insertUpdatedItemProcessing", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteItemProcessing: ({commit, getters}, itemProcessingId) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemProcessing].delete(itemProcessingId).then(
        resp => {
          commit("removeItemProcessing", itemProcessingId);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addItemFabrication: ({commit, getters}, { data, replaceIndex }) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemFabrications].post(data).then(
        resp => {
          commit("insertItemFabrication", { 
            data: resp.data, replaceIndex: replaceIndex 
          });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateItemFabrication: ({commit, getters}, {itemFabricationId, data}) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemFabrication].put(itemFabricationId, data).then(
        resp => {
          commit("insertUpdatedItemFabrication", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteItemFabrication: ({commit, getters}, itemFabricationId) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemFabrication].delete(itemFabricationId).then(
        resp => {
          commit("removeItemFabrication", itemFabricationId);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addItemInstallation: ({commit, getters}, { data, replaceIndex }) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemInstallations].post(data).then(
        resp => {
          commit("insertItemInstallation", { 
            data: resp.data, replaceIndex: replaceIndex 
          });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateItemInstallation: ({commit, getters}, {itemInstallationId, data}) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemInstallation].put(itemInstallationId, data).then(
        resp => {
          commit("insertUpdatedItemInstallation", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteItemInstallation: ({commit, getters}, itemInstallationId) => {
    return new Promise((resolve, reject) => {
      calls[getters.estimationItemInstallation].delete(itemInstallationId).then(
        resp => {
          commit("removeItemInstallation", itemInstallationId);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  regenerateToken: ({commit, getters}, { rfqId, data }) => {
    return new Promise((resolve, reject) => {
      calls[getters.rfqEndpoint].generateToken(rfqId, data).then(
        resp => {
          commit("updateToken", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Token successfully regenerated'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  blacklistToken: ({commit, getters}, rfqId) => {
    return new Promise((resolve, reject) => {
      calls[getters.rfqEndpoint].blacklistToken(rfqId).then(
        resp => {
          commit("removeToken", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Token successfully disabled'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setRfq(state, data) {
    if (data && data.c_estimation && data.c_estimation.items) {
      data.c_estimation.items = data.c_estimation.items.sort((a,b) => {
        if (a.order == b.order) {
          return +a.id - +b.id;
        } else {
          return +a.order - +b.order;
        }
      });

      data.c_estimation.items.forEach(item => {
        item.materials.sort((a,b) => +b.product_master.product_category_id -
          +a.product_master.product_category_id);
        item.processing.sort((a,b) => +a.processing.processing_type_id - 
          +b.processing.processing_type_id);
        item.fabrications.sort((a,b) => +a.fabrication.fabrication_type_id - 
          +b.fabrication.fabrication_type_id);
        item.installations.sort((a,b) => +a.installation.installation_type_id - 
          +b.installation.installation_type_id);
      });
      data.c_estimation.services.sort((a,b) => +a.service.id - +b.service.id);
    }

    if (data && data.drawing_highlights && data.drawing_highlights.length > 0) {
      data.drawing_highlights[0].files.sort((a,b) => +a.id - +b.id);
    }
    
    state.rfq = data;
  },
  insertDocument(state, data) {
    state.rfq.documents.push(data);
  },
  insertUpdatedDocument(state, data) {
    state.rfq.documents.forEach((document, i) => {
      if (document.id == data.id) {
        state.rfq.documents.splice(i, 1, data);
      }
    })
  },
  removeDocument(state, documentId) {
    state.rfq.documents.forEach((document, i) => {
      if (document.id == documentId) {
        state.rfq.documents.splice(i, 1);
      }
    })
  },
  insertService(state, data) {
    state.rfq.c_estimation.services.push(data);
  },
  removeService(state, serviceId) {
    state.rfq.c_estimation.services.forEach((service, i) => {
      if (service.id == serviceId) {
        state.rfq.c_estimation.services.splice(i, 1);
      }
    })
  },
  insertEstimation(state, data) {
    state.rfq.c_estimation = data;
  },
  insertItem(state, data) {
    state.rfq.c_estimation.items.push(data)
  },
  insertUpdatedItem(state, data) {
    state.rfq.c_estimation.items.forEach((item, i) => {
      if (item.id == data.id) {
        state.rfq.c_estimation.items.splice(i, 1, data);
      }
    })
  },
  removeItem(state, itemId) {
    state.rfq.c_estimation.items.forEach((item, i) => {
      if (item.id == itemId) {
        state.rfq.c_estimation.items.splice(i, 1);
      }
    })
  },
  addFacing(state, itemIndex) {
    state.rfq.c_estimation.items[itemIndex].materials.push({
      id: null,
      product_master_id: null,
      product_master: {
        product_category_id: 13
      }
    })
  },
  addBacking(state, itemIndex) {
    state.rfq.c_estimation.items[itemIndex].materials.push({
      id: null,
      product_master_id: null,
      product_master: {
        product_category_id: 14
      }
    })
  },
  addRailing(state, itemIndex) {
    state.rfq.c_estimation.items[itemIndex].materials.push({
      id: null,
      product_master_id: null,
      product_master: {
        product_category_id: 20
      }
    })
  },
  remove(state, {section, itemIndex, subItemIndex}) {
    state.rfq.c_estimation.items[itemIndex][section].splice(subItemIndex, 1);
  },
  addProcessing(state, { itemIndex, processingType }) {
    state.rfq.c_estimation.items[itemIndex].processing.push({
      id: null,
      processing_id: null,
      processing: {
        processing_type: processingType
      }
    })
  },
  addFabrication(state, { itemIndex, fabricationType }) {
    state.rfq.c_estimation.items[itemIndex].fabrications.push({
      id: null,
      fabrication_id: null,
      fabrication: {
        fabrication_type: fabricationType
      }
    })
  },
  addInstallation(state, { itemIndex, installationType }) {
    state.rfq.c_estimation.items[itemIndex].installations.push({
      id: null,
      installation_id: null,
      installation: {
        installation_type: installationType
      }
    })
  },
  insertItemMaterial(state, { data, replaceIndex }) {
    state.rfq.c_estimation.items.forEach(item => {
      if (item.id == data.estimation_item_id) {
        if (!isNaN(replaceIndex)) {
          item.materials.splice(replaceIndex, 1, data);
        } else {
          item.materials.push(data)
        }
      }
    })
  },
  insertUpdatedItemMaterial(state, data) {
    state.rfq.c_estimation.items.forEach(item => {
      if (item.id == data.estimation_item_id) {
        item.materials.forEach((material, i) => {
          if (material.id == data.id) {
            item.materials.splice(i, 1, data);
          }
        })
      }
    })
  },
  removeItemMaterial(state, itemMaterialId) {
    state.rfq.c_estimation.items.forEach(item => {
      item.materials.forEach((material, i) => {
        if (material.id == itemMaterialId) {
          item.materials.splice(i, 1);
        }
      })
    })
  },
  insertItemProcessing(state, { data, replaceIndex }) {
    state.rfq.c_estimation.items.forEach(item => {
      if (item.id == data.estimation_item_id) {
        if (!isNaN(replaceIndex)) {
          item.processing.splice(replaceIndex, 1, data);
        } else {
          item.processing.push(data);
        }
      }
    })
  },
  insertUpdatedItemProcessing(state, data) {
    state.rfq.c_estimation.items.forEach(item => {
      if (item.id == data.estimation_item_id) {
        item.processing.forEach((processing, i) => {
          if (processing.id == data.id) {
            item.processing.splice(i, 1, data);
          }
        })
      }
    })
  },
  removeItemProcessing(state, itemProcessingId) {
    state.rfq.c_estimation.items.forEach(item => {
      item.processing.forEach((processing, i) => {
        if (processing.id == itemProcessingId) {
          item.processing.splice(i, 1);
        }
      })
    })
  },
  insertItemFabrication(state, { data, replaceIndex }) {
    state.rfq.c_estimation.items.forEach(item => {
      if (item.id == data.estimation_item_id) {
        if (!isNaN(replaceIndex)) {
          item.fabrications.splice(replaceIndex, 1, data);
        } else {
          item.fabrications.push(data)
        }
      }
    })
  },
  insertUpdatedItemFabrication(state, data) {
    state.rfq.c_estimation.items.forEach(item => {
      if (item.id == data.estimation_item_id) {
        item.fabrications.forEach((fabrication, i) => {
          if (fabrication.id == data.id) {
            item.fabrications.splice(i, 1, data);
          }
        })
      }
    })
  },
  removeItemFabrication(state, itemFabricationId) {
    state.rfq.c_estimation.items.forEach(item => {
      item.fabrications.forEach((fabrication, i) => {
        if (fabrication.id == itemFabricationId) {
          item.fabrications.splice(i, 1);
        }
      })
    })
  },
  insertItemInstallation(state, { data, replaceIndex }) {
    state.rfq.c_estimation.items.forEach(item => {
      if (item.id == data.estimation_item_id) {
        if (!isNaN(replaceIndex)) {
          item.installations.splice(replaceIndex, 1, data);
        } else {
          item.installations.push(data)
        }
      }
    })
  },
  insertUpdatedItemInstallation(state, data) {
    state.rfq.c_estimation.items.forEach(item => {
      if (item.id == data.estimation_item_id) {
        item.installations.forEach((installation, i) => {
          if (installation.id == data.id) {
            item.installations.splice(i, 1, data);
          }
        })
      }
    })
  },
  removeItemInstallation(state, itemInstallationId) {
    state.rfq.c_estimation.items.forEach(item => {
      item.installations.forEach((installation, i) => {
        if (installation.id == itemInstallationId) {
          item.installations.splice(i, 1);
        }
      })
    })
  }, 
  updateToken(state, data) {
    state.rfq.api_token = data.api_token;
    state.rfq.token_expiration_date = data.token_expiration_date;
  },
  removeToken(state, data) {
    state.rfq.token_expiration_date = data.token_expiration_date;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}